import { styles } from './template.scss';
import { styles as commonStyles } from '../../../assets/common.scss';

export const templateLicenseMainForm = document.createElement('template');

templateLicenseMainForm.innerHTML = `
  <style>${commonStyles}</style>
  <style>${styles}</style>

  <div id='wrapper'>
    <gz-title fontSize='11' fontWeight='600' class='form-subtitle' id='licensing-title'></gz-title>

    <gz-form-field id='license-type-form-field' class='label-mw-250' label='' required>
      <gz-dropdown gz-form-input type='dropdown'></gz-dropdown>
      <gz-input-error></gz-input-error>
    </gz-form-field>

    <p class='form-subtitle-info hidden' id='license-type-info-message'></p>

    <section id='subform-section'>
      <gz-license-trial-subform class='hidden'></gz-license-trial-subform>
      <gz-license-frat-subform class='hidden'></gz-license-frat-subform>
      <gz-license-pre-paid-subform class='hidden'></gz-license-pre-paid-subform>
      <gz-license-basic-monthly-subscription-subform class='hidden'></gz-license-basic-monthly-subscription-subform>
      <gz-license-monthly-license-trial-subform class='hidden'></gz-license-monthly-license-trial-subform>
      <gz-license-monthly-subscription-trial-subform class='hidden'></gz-license-monthly-subscription-trial-subform>
      <gz-license-monthly-subscription-subform class='hidden'></gz-license-monthly-subscription-subform>
    </section>
  </div>
`;
